import { render, staticRenderFns } from "./SidepanelOptions.vue?vue&type=template&id=39e16909&"
import script from "./SidepanelOptions.vue?vue&type=script&lang=js&"
export * from "./SidepanelOptions.vue?vue&type=script&lang=js&"
import style0 from "./SidepanelOptions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports